export const ONBOARDING_PAGE_TITLE_CLASS =
  "text-[20px] font-semibold leading-[1.12] tracking-[-0.03em] sm:text-[34px] md:text-[40px]";

export const ONBOARDING_SERVICE_SETUP_TITLE_CLASS =
  "text-balance text-[40px] font-semibold leading-[1] tracking-[-0.05em] sm:text-[64px]";

export const ONBOARDING_PAGE_SUBTITLE_CLASS =
  "text-[18px] font-medium leading-7";

export const ONBOARDING_SECTION_TITLE_CLASS =
  "text-2xl font-medium leading-tight tracking-[-0.02em]";

export const ONBOARDING_SECTION_DESCRIPTION_CLASS =
  "text-base font-normal leading-7";

export const ONBOARDING_CARD_TITLE_CLASS = ONBOARDING_SECTION_TITLE_CLASS;

export const ONBOARDING_CARD_DESCRIPTION_CLASS =
  ONBOARDING_SECTION_DESCRIPTION_CLASS;

export const ONBOARDING_FIELD_LABEL_CLASS =
  "text-sm font-medium leading-5 tracking-normal text-white";

export const ONBOARDING_STEP_NUMBER_CLASS =
  "hidden shrink-0 text-sm font-medium sm:inline";

export const ONBOARDING_STEP_LABEL_CLASS =
  "min-w-0 text-center text-sm leading-5 transition-[opacity,color] duration-300 ease-out";

export const ONBOARDING_FOOTER_PRIMARY_BUTTON_CLASS =
  "h-11 px-10 text-base font-medium disabled:opacity-100 disabled:bg-primary disabled:text-primary-foreground !text-white keep-white dark:!text-black";

export const ONBOARDING_FOOTER_SECONDARY_BUTTON_CLASS =
  "h-11 px-6 text-base font-normal";

export const ONBOARDING_SERVICE_SKIP_BUTTON_CLASS =
  "h-auto w-fit px-0 py-0 text-xs font-normal leading-none text-white/75 hover:text-white hover:!bg-transparent hover:underline sm:h-11 sm:px-6 sm:text-base";
